import React, { useState } from 'react'
import { Tooltip, Badge, Input } from 'reactstrap'


const ExcludedCell = ({ onEditClicked, cell, row, rowIndex }) => {

  const [tooltipOpen, setTooltipOpen] = useState(false)
  const toggle = () => setTooltipOpen(!tooltipOpen)

  return (
    <span style={{ cursor: 'pointer' }}>
        {row.excludedFromAgreement && (
            <Tooltip placement="top" isOpen={tooltipOpen} target={`exclusionToolTip${rowIndex}`} toggle={toggle}>
            {row.excludedReason ? row.excludedReason : 'None'}
            </Tooltip>
        )}
        <Badge
        style={{
            float: 'right',
            marginRight: '20px',
            marginTop: '3px',
        }}
        color="secondary"
        onClick={() => onEditClicked(row)}
            >
                edit
        </Badge>
    </span>
  )
}

export default ExcludedCell
